const DB_NAME = 'MP3Database';
const DB_VERSION = 3;
const STORE_NAME = 'mp3Files';

let db = null;

async function initDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = () => reject(request.error);
        request.onsuccess = () => {
            db = request.result;
            resolve();
        };

        request.onupgradeneeded = (event) => {
            const database = event.target.result;
            if (!database.objectStoreNames.contains(STORE_NAME)) {
                database.createObjectStore(STORE_NAME, { keyPath: 'id' });
            }
        };
    });
}

async function saveFile(fileData) {
    if (!db) {
        await initDB();
    }
    return runStoreTransaction('readwrite', (store) => store.add(fileData));
}

function runStoreTransaction(mode, operation) {
    return new Promise((resolve, reject) => {
        const transaction = db.transaction([STORE_NAME], mode);
        const store = transaction.objectStore(STORE_NAME);
        const request = operation(store);
        let result;
        let requestError = null;

        request.onerror = () => {
            requestError = request.error;
        };
        request.onsuccess = () => {
            result = request.result;
        };
        transaction.oncomplete = () => resolve(result);
        transaction.onerror = () => {
            requestError = transaction.error || requestError;
        };
        transaction.onabort = () => {
            reject(requestError || transaction.error || new Error('IndexedDB transaction aborted'));
        };
    });
}

async function getFile(id) {
    if (!db) {
        await initDB();
    }
    return new Promise((resolve, reject) => {
        const transaction = db.transaction([STORE_NAME], 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.get(id);

        request.onerror = () => reject(request.error);
        request.onsuccess = () => {
            if (request.result) {
                resolve(request.result);
            } else {
                resolve(null); // File not found
            }
        };
    });
}

async function deleteFile(id) {
    if (!db) {
        await initDB();
    }
    await runStoreTransaction('readwrite', (store) => store.delete(id));
}

export { initDB, saveFile, getFile, deleteFile };
